import $ from 'jquery';
import {Swiper, Pagination, Navigation} from 'swiper/js/swiper.esm.js';
Swiper.use([Pagination, Navigation]);

const largeTestimonialSwiper = new Swiper('.swiper-testimonial', {
	loop: true,
	autoplay: true,
	slidesPerView: 1,
	spaceBetween: 0,
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});

const testimonialSwiper = new Swiper('.testimonial-slider', {
	direction: 'horizontal',
	slidesPerView: 1,
	autoHeight: false,
	loop: true,
	spaceBetween: 75,
	speed: 800,
	centeredSlides: true,
	autoplay: {
		delay: 4000,
	},
	pagination: {
		el: '.testimonial-swiper-pagination',
		type: 'bullets',
		clickable: true,
	},
	navigation:{
		nextEl: ".testimonial-swiper-button-next",
		prevEl: ".testimonial-swiper-button-prev",
	},
	breakpoints: {
		600: {
			slidesPerView: 1.2,
		},
		800: {
			slidesPerView: 1.8,
		},
		1200: {
			slidesPerView: 2.2,
		},
	}
});

const servicesSwiper = new Swiper('.services-slider', {
	direction: 'horizontal',
	loop: false,
	slidesPerView: 1,
	spaceBetween: 30,
	navigation: {
		nextEl: ".service-button-next",
		prevEl: ".service-button-prev",
	},
	breakpoints: {
		1300:{
			slidesPerView: 4
		},
		1000: {
			slidesPerView: 3
		},
		650:{
			slidesPerView: 2
		}
	}
});